import { Action, actionCreators } from "../actions";

export interface MessageDropdownInfo {
    roomId: string;
    viewId: string;
    messageId: string;
    isPending: boolean;
    messageRaw?: string;
    messageParsed: string;
    buttonRect: ClientRect;
    historyRect: ClientRect;
    direction: "up" | "down" | null;
    ts: number;
    lastUpdateTs?: number;
    editable?: boolean;
    deletable?: boolean;
    showDeleteConfirm?: boolean;
}

const initialStore = null as MessageDropdownInfo | null;
type Store = typeof initialStore;

export function update(store = initialStore, action: Action): Store {
    switch (action.type) {
        case actionCreators.onLogout.type:
        case actionCreators.onWrongToken.type: {
            return initialStore;
        }
        case actionCreators.setMessageDropdown.type: {
            return action.payload;
        }

        default: {
            return store;
        }
    }
}

export type OuterStore = { messageDropdown: Store };

export function getMessageDropdown(store: OuterStore) {
    return store.messageDropdown;
}
